import { CFAuthGetRef, CFAuthPatchRef } from 'auth';
import { locations } from "../../common/redux/action_locations";
import {
	FETCH_ALL_MU,
	RECEIVED_ALL_MU,
	PATCH_REQUEST_TIMEOFF,
	PATCH_REQUEST_TIMEOFF_COMPLETED
} from "./constants";

export function fetchAllMUAction() {
	return {
        type: FETCH_ALL_MU,
        fetchCall: fetchAllMU,
        receivedAction: receivedAllMU,
        data: {
            locations
        }
    };
}

function fetchAllMU() {
	return CFAuthGetRef({
		url: process.env.REACT_APP_DATA_PROXY_API_URL + '/CCMProxy/GetSecuredManagementUnitDictionary/',
		params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchAllMU'
	});
}

function patchTimeOffRequest(body){
	return CFAuthPatchRef({
        url: process.env.REACT_APP_AP_API_URL + '/TimeoffRequest',
        body,
        originURL: locations.originUrl,
        loaderName: 'patchTimeOffRequest'
    });
}

export function receivedAllMU(data) {
	return {
		type: RECEIVED_ALL_MU,
        MUItems: data
	};
}

export function patchTimeOffRequestAction(body){
	return{
        type: PATCH_REQUEST_TIMEOFF,
        data: {body},
        locations: locations,
        fetchCall: patchTimeOffRequest,
        receivedAction: timeOffRequestPatched
    }
}

function timeOffRequestPatched(res){	

	return {
        type: PATCH_REQUEST_TIMEOFF_COMPLETED,
        response: {
            error: !res.ok,
            responseText: res.message ? res.message : ""
        }
    }
}

export function reducer(state, action) {
	switch (action.type) {
		case RECEIVED_ALL_MU:
		return {
            ...state,
            MUItems: action.MUItems,
		};	
		case PATCH_REQUEST_TIMEOFF_COMPLETED:
		return {
            ...state,
            patchTimeOffResponse: action.response
        };
        default:
		return state;
	}
}



// WEBPACK FOOTER //
// ./src/features/timeoff/redux/supervisor_time_off_actions.js